module.exports = __webpack_public_path__ + "img/nata-2026-conference.a9bcd37f.webp";